import React from 'react';

const BookmarkModal = ({ folder, onClose, isVisible }) => {
    if (!folder) {
        return null;
    }

    return (
        <div className={`modal-overlay ${isVisible ? 'visible' : ''}`} onClick={onClose}>
            <div className={`modal-content ${isVisible ? 'visible' : ''}`} onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>{folder.name}</h2>
                    <button className="modal-close-btn" onClick={onClose}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="bookmarks-grid">
                        {folder.children.map((bookmark, index) => (
                            <div className="bookmark-box" key={index}>
                                <a href={bookmark.url} className="bookmark-link" target="_blank" rel="noopener noreferrer">
                                    <div className="favicon-container">
                                        <img src={bookmark.favicon} alt={bookmark.title} />
                                    </div>
                                    <span className="title">{bookmark.title}</span>
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookmarkModal;